import { Col, Container, Row } from 'react-bootstrap'
import img2 from "../Assets/images/Shape_1.png"
import img9 from "../Assets/images/Vector_Smart_Object_1.png"
import img10 from "../Assets/images/Vector_Smart_Object_2.png"
import img11 from "../Assets/images/Vector_Smart_Object_3.png"
import img23 from "../Assets/images/Frame 98.png"
import { useTranslation } from 'react-i18next';
import arLife from "../Assets/images/Group 106.png"
import ProgramHighlights from '../Components/programHighlights/ProgramHighlights';
import duration from "../Assets/images/duration.png";
import format from "../Assets/images/format.png";
import level from "../Assets/images/levels.png";
import certification from "../Assets/images/certification.png";
import WhatYouGetSection from '../Components/whatYouGetSection/WhatYouGetSection';
import whatYouGetImg from "../Assets/images/wul.png"
import WhoThisProgramIsFor from '../Components/WhoThisProgramIsFor/WhoThisProgramIsFor';
import img20 from "../Assets/images/1.png";
import img21 from "../Assets/images/2.png";
import img22 from "../Assets/images/3.png";
import img24 from "../Assets/images/4.png";
import img25 from "../Assets/images/5.png";
import person from "../Assets/images/Vector_Smart_Object_4.png"
import { Modal } from 'antd'
import { useState } from 'react'
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup'

function ArabicForLife() {

    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const cardsData = [
        { title: t("duration"), details: t("arabic_life_cardData.duration_details"), img: duration },
        { title: t("format"), details: t("arabic_life_cardData.format_details"), img: format },
        { title: t("level"), details: t("arabic_life_cardData.level_details"), img: level },
        { title: t("certification"), details: t("arabic_life_cardData.certification_details"), img: certification },
    ];
    const whatYouGetData = [
        { description: t("functional_arabic") },
        { description: t("vocabulary_expressions") },
        { description: t("listening_speaking") },
        { description: t("interactive_resources") },
        { description: t("student_books") },
    ]
    const whatProgramFor = [
        { img: img20, title: t("non_native_speakers"), desc: t("non_native_speakers_desc") },
        { img: img21, title: t("travelers_expats"), desc: t("travelers_expats_desc") },
        { img: img22, title: t("students"), desc: t("students_desc") },
        { img: img24, title: t("professionals"), desc: t("professionals_desc") },
        { img: img25, title: t("cultural_enthusiasts"), desc: t("cultural_enthusiasts_desc") },
    ];
    return (
        <div className='arabicLife-sec'>

            <section className='first-section position-relative'>
                <Row className='justify-content-start flex-column gx-0'>
                    <Col md={12} className='content-box'>
                        <Container>
                            <img src={img2} alt='' className='my-4' />
                            <h2 className='mb-3 ar-header'>{t("arabic_for_life")}</h2>
                            <h5 className='mb-4'>
                                <h5 className='mb-4'>{t("practical_arabic")}</h5>
                            </h5>

                        </Container>
                    </Col>

                </Row>
                <Row className='justify-content-start flex-column '>
                    <Col md={12} className='green-div'>
                        <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                            <Container>   <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>  {t("start_now")}</button></Container>
                        </div>


                    </Col>

                </Row>
                <img src={arLife} alt='' className='ar-life-logo' />
            </section>


            <section>
                <Container>
                    <ProgramHighlights cardsData={cardsData} color='#E2F3D1' />
                    <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
                </Container>
            </section>

            <section className='my-5'>
                <WhoThisProgramIsFor data={whatProgramFor} />
            </section>

            <section className='fifth-section position-relative'>
                <Container>
                    <Row>
                        <Col md={6}>
                            <span>{t("program_units_title")}</span>
                            <p>{t("program_units_description")}</p>
                        </Col>
                        <Col md={6} className='hiddenImage'>
                            <img src={person} alt='' width={"300px"} height={"300px"} />
                        </Col>
                    </Row>

                    <img src={person} alt='' className='top-right-img' />
                </Container>
            </section>



            <section className='third-section  mb-4'>
                <Container>
                    <h5>{t("learning_experience")}</h5>
                    <Row className="pt-4 gy-5">
                        <Col md={4}>
                            <div className="d-flex align-items-center flex-column">
                                <img src={img9} alt="" />
                                <div className="mx-3">
                                    <h6>{t("units_practical_arabic")}</h6>
                                    <p>{t("units_practical_arabic_desc")}</p>
                                </div>
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="d-flex align-items-center flex-column">
                                <img src={img10} alt="" />
                                <div className="mx-3">
                                    <h6>{t("interactive_online_edition")}</h6>
                                    <p>{t("interactive_online_edition_desc")}</p>
                                </div>
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="d-flex align-items-center flex-column">
                                <img src={img11} alt="" />
                                <div className="mx-3">
                                    <h6>{t("cultural_bridges")}</h6>
                                    <p>{t("cultural_bridges_desc")}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>

            <section className=' last-sec '>
                <Container>
                    <Row className='align-items-center justify-content-between'>
                        <Col md={7}>
                            <h6>{t("daily_communication_title")}</h6>
                            <p>{t("daily_communication_subtitle")}</p>
                            <button onClick={() => setIsModalOpen(true)}>{t("daily_communication_button")}</button>

                        </Col>
                        <Col md={5}>
                            <img src={img23} alt='' className='w-100' />
                        </Col>
                    </Row>
                </Container>
            </section>
            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"}

            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>

    )
}

export default ArabicForLife
